import React, { useRef } from "react";
import { YHModal } from "@/components/YHModal";
import { useSaleSoDetailModel } from "./saleSoDetailModel";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";


export const DiscountModel = () => {
    const { discountModal: visible, setDiscountModal } = useSaleSoDetailModel();
    const formRef = useRef<IYhFormRef>();

    const onCancel = () => {
        setDiscountModal(false);
    };
    const onFinish = (val: any) => {

    }
    //监听批量录入字段
    const onChange = (changedValues: { [key: string]: any }) => {
        if ('isBatch' in changedValues) {
        }
    }

    //表单提交
    const onSubmit = async () => {

    }

    const ItemBox: IYhFormItemsBox = {
        style: { padding: "60px 30px 80px 10px" },
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "折扣类型",
                fieldName: "note",
                options: [{ label: "1", value: "1" }],
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "折扣系数",
                fieldName: "code",
                span: 24,
                suffix: "%"
            }
        ]
    }
    const formConfig: IYhFormBox = {
        formRef,
        onFinish,
        formValues: {},
        labelCol: { span: 6 },
        onChange,
        boxs: [ItemBox]
    };
    return <YHModal
        visible={visible}
        onOk={onCancel}
        onCancel={onCancel}
        title="请输入全部系数折扣"
        width={500}
        bodyHeight={200}
        showFooter={true}
    >
        <YhFormBox {...formConfig} />
    </YHModal>
}
